import axios from 'axios';
import { logoutIfSessionExpired } from './session';

const httpClient = axios.create({
    // baseURL: "http://localhost:5000/api/",
    baseURL: "https://api.alkauseradmissions.net/api/"
});

httpClient.interceptors.request.use(function (config) {
    // Auto logout after 24h — block requests and redirect to login
    if (logoutIfSessionExpired()) {
        window.location.replace('/');
        return Promise.reject(new Error('Session expired'));
    }
    const token = localStorage.getItem('authToken');
    config.headers.Authorization = token ? `Bearer ${token}` : '';
    return config;
}, function (error) { return Promise.reject(error); });


export default httpClient;